<template>
  <div>
    <data-table :service="CountryService"
                service-method="getAll"
                :entity="entity"
                :columns="columns"
                :filters="filters"
                operations="delete"
                :go-to-details-on-row-click="false"
                :go-to-add-on-click="false"
                :show-confirm-before-delete="false"
                :clickable="false"
                @on-add="addRow"
                ref="table">
      <b slot="code" slot-scope="{row, index}">
        {{row.code}}
      </b>
      <b slot="name" slot-scope="{row, index}">
        <editable-grid-cell :value="row.name"
                            placeholder="Name"
                            :show-input="!row.id"
                            @keyup.enter="trySave(row, index)"
                            @change="(val) => updateCountry(val, 'name', row, index)">
          {{row.name}}
        </editable-grid-cell>
      </b>
      <div class="d-flex align-items-center" slot="primary" slot-scope="{row, index}">
        <base-switch :value="row.primary"
                     @input="(val) => setPrimaryCountry(val, row, index)"
                     on-text="YES"
                     off-text="NO">
        </base-switch>
      </div>
      <div class="d-flex align-items-center" slot="active" slot-scope="{row, index}">
        <base-switch :value="row.active"
                     @input="(val) => updateCountry(val, 'active', row, index)"
                     on-text="YES"
                     off-text="NO">
        </base-switch>
      </div>
      <div class="d-flex align-items-center" slot="search" slot-scope="{row, index}">
        <base-switch :value="row.search"
                     @input="(val) => updateCountry(val, 'search', row, index)"
                     on-text="YES"
                     off-text="NO">
        </base-switch>
      </div>
    </data-table>
  </div>
</template>
<script>
  import LanguageSelect from "src/components/LanguageSelect";
  import CountryService from 'src/services/CountryService';
  import EditableGridCell from 'src/components/EditableGridCell';
  import entities from 'src/config/entities';

  export default {
    name: 'country-settings',
    components: {
      EditableGridCell,
      LanguageSelect
    },
    data() {
      return {
        CountryService,
        entity: entities.COUNTRY,
        saving: false,
        selectedLocale: this.$i18n.locale
      }
    },
    computed: {
      columns() {
        return [
          {
            prop: "code",
            label: this.$t('settings.country.labels.countryCode'),
            sortable: true,
            minWidth: "120px",
          },
          {
            prop: "name",
            label: this.$t('settings.country.labels.country'),
            minWidth: "140px",
            sortable: true
          },
          {
            prop: "primary",
            label: this.$t('settings.country.labels.primary'),
            minWidth: "80px",
            sortable: true
          },
          {
            prop: "active",
            label: this.$t('settings.country.labels.active'),
            minWidth: "80px",
            sortable: true
          },
          {
            prop: "search",
            label: this.$t('generic.search'),
            minWidth: "80px",
            sortable: true
          }
        ]
      },
      filters() {
        return [
          {
            key: 'sort',
            value: '+active,-name'
          }
        ]
      }
    },
    methods: {
      async updateCountry(evt, key, row, index = 0) {
        let value = evt.target ? evt.target.value : evt;
        this.saving = true;
        let id = row.id;
        if (id) {
          let data = {
            ...row,
            [key]: value
          };
          await CountryService.update(id, data);
          row[key] = value;
        } else {
          row[key] = value;
        }
        this.saving = false;
      },
      async disablePrevPrimary() {
        let currentPrimary = this.$refs.table.tableData.find(row => row.primary === true);
        if (!currentPrimary) return;
        currentPrimary.primary = false;
        await CountryService.update(currentPrimary.id, currentPrimary);
      },
      async setPrimaryCountry(val, row, index) {
        if (val) {
          await this.disablePrevPrimary();
          row.primary = val;
          if (!row.active) {
            row.active = true;
          }
          await CountryService.update(row.id, row);
          this.$refs.table.tableData.splice(index, 1, row);
        } else {
          row.primary = false;
          await CountryService.update(row.id, row);
          this.$refs.table.tableData.splice(index, 1, row);
        }
      },
      async trySave(row, index) {
        if (!row.id) {
          await this.saveCountry(row, index)
        }
      },
      async saveCountry(row, index = 0) {
        let result = await CountryService.create(row);
        this.$refs.table.tableData.splice(index, 1, result.data);
      },
      async addRow(index = 0) {
        let row = {
          locale: this.selectedLocale,
          country_code: '',
          country: '',
          primary: false,
          active: false
        };
        this.$refs.table.tableData.splice(index, 0, row);
      }
    }
  }
</script>
<style>
</style>
